/*! Ardor Printing flag 3D preview v1.0 (window.ArdorFlag3D).
 * Needs global THREE (r147) and THREE.OrbitControls loaded first. No other files, no network loads.
 * Units are inches, y up, the flag faces +z ("front"). */
(function (root) {
  "use strict";

  var FOV = 28, EL_MAX = 1.05, EL_MIN = 0.03, DEFAULT_BG = "#f4f6f5", PI = Math.PI,
    FILL_HOME = 0.9, FILL_NEAR = 0.97, FILL_FAR = 0.42, IDLE_MS = 30000, FRAME_MS = 33;

  // Assembled height (pole + base, inches) per flag key, used to place the flag above its base.
  var HEIGHTS = {
    "FA-S": 108, "FA-M": 126, "FA-L": 168, "FA-XL": 216, "FC-S": 108, "FC-M": 126, "FC-L": 168, "FC-XL": 216,
    "FE-16": 192, "TD-S": 84, "TD-M": 108, "TD-L": 134.4, "TD-XL": 162, "TD-DESK": 22,
    "RC-S": 102, "RC-M": 141.6, "RC-L": 180
  };
  // Fallback graphic size per shape when w/h are not given.
  var DEF_SIZE = {
    "feather-angled": [28, 138], "feather-convex": [24, 104], "feather-econo": [24, 150], teardrop: [36, 96],
    "teardrop-desk": [8, 16], rectangle: [31, 114], "pole-flag": [60, 36]
  };
  var KITS = { none: 1, "ground-stake": 1, "cross-base": 1, "cross-water": 1, "square-base": 1 };

  function hasThree() {
    var T = root.THREE;
    return !!(T && T.WebGLRenderer && T.OrbitControls && T.BufferGeometry && T.MeshLambertMaterial &&
      T.TubeGeometry && T.CatmullRomCurve3 && T.ShapeUtils && T.CanvasTexture);
  }

  function create(host, opts) {
    try { return !host || !hasThree() ? null : build(host, opts || {}); } catch (e) {
      try { // clean up a half-built viewer so the page can fall back to 2D
        var cs = host.querySelectorAll("canvas[data-ardor-flag3d='init']"), i, gl, ext;
        for (i = 0; i < cs.length; i++) {
          gl = cs[i].getContext("webgl2") || cs[i].getContext("webgl");
          ext = gl && gl.getExtension("WEBGL_lose_context");
          if (ext) ext.loseContext();
          if (cs[i].parentNode) cs[i].parentNode.removeChild(cs[i]);
        }
      } catch (e2) { }
      return null;
    }
  }

  /* ---------- input helpers ---------- */
  function num(v, lo, hi) {
    var n = Number(v);
    return v !== null && v !== "" && v !== true && v !== false && isFinite(n) && n >= lo && n <= hi ? n : null;
  }
  function str(v) { return v === null || v === undefined ? "" : String(v).toLowerCase().replace(/^\s+|\s+$/g, ""); }
  function sidesOf(v) {
    if (v === 1 || v === 2) return v;
    var s = str(v);
    return s.charAt(0) === "2" || s.indexOf("double") >= 0 || s.indexOf("two") === 0 ? 2 :
      s.charAt(0) === "1" || s.indexOf("single") >= 0 || s.indexOf("one") === 0 ? 1 : 0;
  }
  function sleeveOf(v) { var s = str(v).charAt(0); return s === "r" ? "right" : s === "l" ? "left" : null; }
  function kitOf(v) {
    var s = str(v);
    if (!s) return null;
    if (KITS[s]) return s;
    if (s.indexOf("water") >= 0) return "cross-water";
    if (s.indexOf("cross") >= 0) return "cross-base";
    if (s.indexOf("stake") >= 0 || s.indexOf("spike") >= 0 || s.indexOf("ground") >= 0) return "ground-stake";
    if (s.indexOf("square") >= 0 || s.indexOf("plate") >= 0) return "square-base";
    if (s.indexOf("only") >= 0 || s.indexOf("none") >= 0 || s === "no") return "none";
    return null;
  }
  function keyOf(v) { return typeof v === "string" ? v.replace(/^\s+|\s+$/g, "").toUpperCase() : ""; }
  function shapeOf(v, key) {
    var s = str(v);
    if (DEF_SIZE[s]) return s;
    if (s.indexOf("desk") >= 0) return "teardrop-desk";
    if (s.indexOf("tear") >= 0) return "teardrop";
    if (s.indexOf("convex") >= 0) return "feather-convex";
    if (s.indexOf("econo") >= 0) return "feather-econo";
    if (s.indexOf("feather") >= 0 || s.indexOf("angled") >= 0) return "feather-angled";
    if (s.indexOf("rect") >= 0) return "rectangle";
    if (s.indexOf("pole") >= 0) return "pole-flag";
    var k = key.slice(0, 2);
    return key === "TD-DESK" ? "teardrop-desk" : k === "FA" ? "feather-angled" : k === "FC" ? "feather-convex" :
      k === "FE" ? "feather-econo" : k === "TD" ? "teardrop" : k === "RC" ? "rectangle" : k === "PF" ? "pole-flag" : null;
  }
  function cleanOutline(v) {
    if (!v || typeof v.length !== "number" || v.length < 3) return null;
    var out = [], i, p, x, y, n;
    for (i = 0; i < v.length && i < 5000; i++) {
      p = v[i];
      if (!p || typeof p !== "object") continue;
      x = Number(p.length !== undefined ? p[0] : p.x);
      y = Number(p.length !== undefined ? p[1] : p.y);
      if (!isFinite(x) || !isFinite(y)) continue;
      n = out.length;
      if (n && Math.abs(out[n - 1][0] - x) < 1e-4 && Math.abs(out[n - 1][1] - y) < 1e-4) continue;
      out.push([x, y]);
    }
    while (out.length > 2 && Math.abs(out[0][0] - out[out.length - 1][0]) < 1e-4 &&
      Math.abs(out[0][1] - out[out.length - 1][1]) < 1e-4) out.pop();
    return out.length >= 3 && Math.abs(area(out)) > 0.5 ? out : null;
  }
  function hashPts(p) {
    if (!p) return "none";
    var h = 0, i;
    for (i = 0; i < p.length; i++) h = (h * 31 + Math.round(p[i][0] * 997) * 7 + Math.round(p[i][1] * 991)) % 2147483647;
    return p.length + ":" + h;
  }
  function bgColor(v) { return typeof v === "string" && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v.trim()) ? v.trim() : DEFAULT_BG; }

  /* ---------- 2D geometry (inches, y down, pole on the left = "canonical") ---------- */
  function area(p) {
    var a = 0, i, j;
    for (i = 0, j = p.length - 1; i < p.length; j = i++) a += p[j][0] * p[i][1] - p[i][0] * p[j][1];
    return a / 2;
  }
  function dist(a, b) { return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1])); }
  function segDist(p, a, b) {
    var dx = b[0] - a[0], dy = b[1] - a[1], L = dx * dx + dy * dy,
      t = L > 0 ? Math.max(0, Math.min(1, ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / L)) : 0;
    return Math.sqrt(Math.pow(a[0] + dx * t - p[0], 2) + Math.pow(a[1] + dy * t - p[1], 2));
  }
  function arc(out, cx, cy, rx, ry, t0, t1, n) {
    for (var i = 1; i <= n; i++) {
      var t = t0 + (t1 - t0) * i / n;
      out.push([cx + rx * Math.cos(t), cy + ry * Math.sin(t)]);
    }
  }
  function defaultOutline(shape, w, h) {
    var p, c, a, R;
    if (shape === "rectangle" || shape === "pole-flag") return [[0, h], [0, 0], [w, 0], [w, h]];
    if (shape === "teardrop" || shape === "teardrop-desk") {
      // elliptical head (taller than wide), straight free edge back to the bottom tip
      R = Math.min(w / 2, h * 0.4);
      var ry = Math.min(1.45 * R, h * 0.42), hs = h * R / ry, phi = Math.atan2(hs - R, -R),
        d = Math.sqrt(R * R + (hs - R) * (hs - R)), al = Math.acos(Math.min(1, R / d));
      p = [[0, h], [0, ry]];
      arc(p, R, ry, R, ry, PI, phi - al + 2 * PI, 56);
      return p;
    }
    // feathers (shapes measured from the supplier's cut lines): the pole edge curves over to the top
    // outer corner; "convex" has a rounded bottom that sweeps back to the pole, "angled" a straight cut.
    if (shape === "feather-convex") {
      c = Math.min(0.16 * h, 1.3 * w); a = Math.min(w, 0.15 * h);
      p = [[0, h], [0, c]];
      arc(p, w, c, w, c, PI, 1.5 * PI, 26);
      p.push([w, h - a]);
      arc(p, 0, h - a, w, a, 0, 0.5 * PI, 24);
      p.pop();
      return p;
    }
    c = Math.min(0.36 * h, 1.9 * w); a = Math.min(0.55 * w, 0.2 * h);
    p = [[0, h], [0, c]];
    arc(p, w, c, w, c, PI, 1.5 * PI, 30);
    p.push([w, h - a]);
    return p;
  }
  // The boundary run the pole sleeve covers: from the bottom of the sleeve edge, up and over the top.
  function polePath(p, shape) {
    var n = p.length, i, k, minX = Infinity, minY = Infinity, maxY = -Infinity, maxX = -Infinity;
    for (i = 0; i < n; i++) {
      minX = Math.min(minX, p[i][0]); maxX = Math.max(maxX, p[i][0]);
      minY = Math.min(minY, p[i][1]); maxY = Math.max(maxY, p[i][1]);
    }
    var w = maxX - minX, H = maxY - minY, tol = Math.max(0.75, 0.04 * w), s = -1, per = 0;
    for (i = 0; i < n; i++) if (p[i][0] <= minX + tol && (s < 0 || p[i][1] > p[s][1])) s = i;
    for (i = 0; i < n; i++) per += dist(p[i], p[(i + 1) % n]);
    function probe(dir) {
      var j = s, acc = 0, c = 0, q;
      while (acc < per * 0.04 && c++ < n) { q = (j + dir + n) % n; acc += dist(p[j], p[q]); j = q; }
      return p[j];
    }
    var A = probe(1), B = probe(-1),
      dir = A[0] < B[0] - 1e-6 || (Math.abs(A[0] - B[0]) <= 1e-6 && A[1] <= B[1]) ? 1 : -1, seq = [], end = n - 1;
    for (k = 0; k < n; k++) seq.push(p[((s + dir * k) % n + n) % n]);
    if (shape === "teardrop" || shape === "teardrop-desk") {
      // the free edge is the straight run that comes back to the bottom tip
      var S = seq[0], tl = 0.006 * Math.max(w, H) + 0.05, ok, m;
      for (k = n - 1; k > 1; k--) {
        ok = true;
        for (m = k + 1; m < n && ok; m++) if (segDist(seq[m], seq[k], S) > tl) ok = false;
        if (!ok || seq[k][1] < minY + 0.25 * H) break;
        end = k;
      }
      while (end > 1 && seq[end][1] > minY + 0.62 * H) end--;
    } else {
      for (k = 1; k < n - 1; k++) {
        var q = k + 1;
        while (q < n - 1 && dist(seq[k], seq[q]) < 0.4) q++;
        var dx = seq[q][0] - seq[k][0], dy = seq[q][1] - seq[k][1], L = Math.sqrt(dx * dx + dy * dy) || 1;
        if (dy / L > 0.7) { end = k; break; }
      }
    }
    var path = seq.slice(0, end + 1);
    return path.length < 2 ? [[minX, maxY], [minX, minY]] : path;
  }
  function normalOf(a, b) {
    var dx = b[0] - a[0], dy = b[1] - a[1], L = Math.sqrt(dx * dx + dy * dy);
    return L > 1e-9 ? [-dy / L, dx / L] : [0, 0];
  }
  function insetPath(path, off) {
    var n = path.length, out = [], i;
    for (i = 0; i < n; i++) {
      var a = path[Math.max(0, i - 1)], b = path[i], c = path[Math.min(n - 1, i + 1)],
        n1 = normalOf(a, b), n2 = normalOf(b, c), nx = n1[0] + n2[0], ny = n1[1] + n2[1], L = Math.sqrt(nx * nx + ny * ny),
        ref = n2[0] || n2[1] ? n2 : n1;
      if (L < 1e-9) { nx = ref[0]; ny = ref[1]; L = 1; }
      nx /= L; ny /= L;
      var k = off / Math.max(0.5, nx * ref[0] + ny * ref[1]);
      out.push([b[0] + nx * k, b[1] + ny * k]);
    }
    return out;
  }
  function resample(path, step) {
    var out = [path[0].slice()], i, carry = 0;
    for (i = 1; i < path.length; i++) {
      var a = path[i - 1], b = path[i], L = dist(a, b), t = step - carry;
      while (t <= L) { out.push([a[0] + (b[0] - a[0]) * t / L, a[1] + (b[1] - a[1]) * t / L]); t += step; }
      carry = L - (t - step);
    }
    var last = path[path.length - 1];
    if (dist(out[out.length - 1], last) > step * 0.3) out.push(last.slice()); else out[out.length - 1] = last.slice();
    return out;
  }
  function chaikin(path, iters) {
    for (var it = 0; it < iters; it++) {
      var out = [path[0]], i;
      for (i = 0; i < path.length - 1; i++) {
        var a = path[i], b = path[i + 1];
        out.push([a[0] * 0.75 + b[0] * 0.25, a[1] * 0.75 + b[1] * 0.25], [a[0] * 0.25 + b[0] * 0.75, a[1] * 0.25 + b[1] * 0.75]);
      }
      out.push(path[path.length - 1]);
      path = out;
    }
    return path;
  }
  function clipRect(poly, x0, y0, x1, y1) {
    var out = poly, E = [[0, x0, 1], [0, x1, -1], [1, y0, 1], [1, y1, -1]], e, i;
    for (e = 0; e < 4 && out.length; e++) {
      var ax = E[e][0], v = E[e][1], sg = E[e][2], inp = out;
      out = [];
      for (i = 0; i < inp.length; i++) {
        var P = inp[i], Q = inp[(i + 1) % inp.length], pin = (P[ax] - v) * sg >= 0, qin = (Q[ax] - v) * sg >= 0;
        if (pin) out.push(P);
        if (pin !== qin) {
          var t = (v - P[ax]) / (Q[ax] - P[ax]);
          out.push([P[0] + (Q[0] - P[0]) * t, P[1] + (Q[1] - P[1]) * t]);
        }
      }
    }
    return out;
  }
  // Grid mesh clipped exactly to the outline: whole cells inside, cut pieces on the edge.
  function clothMesh(THREE, p, cells) {
    var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity, n = p.length, i, j, k;
    for (i = 0; i < n; i++) {
      minX = Math.min(minX, p[i][0]); maxX = Math.max(maxX, p[i][0]);
      minY = Math.min(minY, p[i][1]); maxY = Math.max(maxY, p[i][1]);
    }
    var W = maxX - minX, H = maxY - minY, cs = Math.max(0.15, Math.sqrt(W * H / cells)),
      nx = Math.max(2, Math.ceil(W / cs)), ny = Math.max(2, Math.ceil(H / cs)), dx = W / nx, dy = H / ny,
      mark = new Uint8Array(nx * ny), vmap = new Int32Array((nx + 1) * (ny + 1)), xs = [], ys = [], idx = [];
    for (i = 0; i < vmap.length; i++) vmap[i] = -1;
    function mk(x, y) { if (x >= 0 && y >= 0 && x < nx && y < ny) mark[y * nx + x] = 1; }
    function cl(v, hi) { return Math.max(0, Math.min(hi - 1e-7, v)); }
    for (i = 0; i < n; i++) {
      var ax = cl((p[i][0] - minX) / dx, nx), ay = cl((p[i][1] - minY) / dy, ny), bx = cl((p[(i + 1) % n][0] - minX) / dx, nx),
        by = cl((p[(i + 1) % n][1] - minY) / dy, ny), cx = Math.min(nx - 1, Math.floor(ax)), cy = Math.min(ny - 1, Math.floor(ay)),
        ddx = bx - ax, ddy = by - ay, sx = ddx > 0 ? 1 : -1, sy = ddy > 0 ? 1 : -1,
        tx = ddx ? (sx > 0 ? Math.floor(ax) + 1 - ax : ax - Math.floor(ax)) / Math.abs(ddx) : Infinity,
        ty = ddy ? (sy > 0 ? Math.floor(ay) + 1 - ay : ay - Math.floor(ay)) / Math.abs(ddy) : Infinity,
        tdx = ddx ? 1 / Math.abs(ddx) : Infinity, tdy = ddy ? 1 / Math.abs(ddy) : Infinity, g = 0;
      mk(cx, cy);
      while (Math.min(tx, ty) <= 1 && g++ < 20000) {
        if (tx < ty) { tx += tdx; cx += sx; } else { ty += tdy; cy += sy; }
        mk(cx, cy);
      }
    }
    function gv(a, b) {
      var key = b * (nx + 1) + a;
      if (vmap[key] < 0) { vmap[key] = xs.length; xs.push(minX + a * dx); ys.push(minY + b * dy); }
      return vmap[key];
    }
    for (j = 0; j < ny; j++) {
      var yc = minY + (j + 0.5) * dy, xc = [];
      for (k = 0; k < n; k++) {
        var P = p[k], Q = p[(k + 1) % n];
        if ((P[1] > yc) !== (Q[1] > yc)) xc.push(P[0] + (yc - P[1]) * (Q[0] - P[0]) / (Q[1] - P[1]));
      }
      xc.sort(function (a, b) { return a - b; });
      for (i = 0; i < nx; i++) {
        var x0 = minX + i * dx, y0 = minY + j * dy;
        if (mark[j * nx + i]) {
          var cp = clipRect(p, x0, y0, x0 + dx, y0 + dy);
          if (cp.length < 3 || Math.abs(area(cp)) < dx * dy * 1e-5) continue;
          var v2 = [], base = xs.length, tri;
          for (k = 0; k < cp.length; k++) { v2.push(new THREE.Vector2(cp[k][0], cp[k][1])); xs.push(cp[k][0]); ys.push(cp[k][1]); }
          tri = THREE.ShapeUtils.triangulateShape(v2, []);
          for (k = 0; k < tri.length; k++) idx.push(base + tri[k][0], base + tri[k][1], base + tri[k][2]);
        } else {
          var c = 0, xm = x0 + dx / 2;
          for (k = 0; k < xc.length && xc[k] < xm; k++) c++;
          if (c % 2) {
            var a0 = gv(i, j), a1 = gv(i + 1, j), a2 = gv(i + 1, j + 1), a3 = gv(i, j + 1);
            idx.push(a0, a1, a2, a0, a2, a3);
          }
        }
      }
    }
    return { xs: xs, ys: ys, idx: idx, minX: minX, minY: minY, maxX: maxX, maxY: maxY };
  }

  /* ---------- procedural textures ---------- */
  function rng(seed) { return function () { seed = seed * 16807 % 2147483647; return seed / 2147483647; }; }

  /* FLAG3D (Oct 20, 2026): poster() draws a still, flat picture of the flag on its pole and base, framed like the 3D view's
     first (home) frame, with a 2D canvas only (no WebGL). The flag builder shows it in the 3D box until the 3D view starts
     (first touch, scroll, key or mouse move, or 8 s after load). Its numbers mirror buildFlag(), buildKit(), paintGround()
     and fitDistance() below. o = the object the builder passes to api.set(); face = the front face canvas; bg = background.
     Undo: restore assets/ardor-flag3d-backup-oct20f3.js. */
  function poster(cv, o, face, bg) {
    o = o || {};
    var dpr = Math.min(2, root.devicePixelRatio || 1), cw = Math.round(cv.clientWidth * dpr), ch = Math.round(cv.clientHeight * dpr);
    if (cw < 8 || ch < 8) return false;
    if (cv.width !== cw) cv.width = cw;
    if (cv.height !== ch) cv.height = ch;
    var g = cv.getContext("2d");
    if (!g) return false;
    var key = keyOf(o.key), shape = shapeOf(o.shape, key) || "feather-angled", isPole = shape === "pole-flag",
      desk = shape === "teardrop-desk", w = num(o.w, 1, 600) || DEF_SIZE[shape][0], h = num(o.h, 1, 600) || DEF_SIZE[shape][1],
      sx = sleeveOf(o.sleeve) === "right" ? -1 : 1, kit = kitOf(o.kit) || "none", src = cleanOutline(o.outline), poly = [], i, k, p;
    if (src) for (i = 0; i < src.length; i++) poly.push([sx < 0 ? w - src[i][0] : src[i][0], src[i][1]]);
    else poly = defaultOutline(shape, w, h);
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (i = 0; i < poly.length; i++) {
      minX = Math.min(minX, poly[i][0]); maxX = Math.max(maxX, poly[i][0]);
      minY = Math.min(minY, poly[i][1]); maxY = Math.max(maxY, poly[i][1]);
    }
    var flagH = maxY - minY, Hk = num(o.height, 6, 600) || HEIGHTS[key] || 0,
      sw = num(o.sleeveWidth, 0.2, 6) || (isPole ? Math.min(2, Math.max(0.6, 0.035 * h)) : desk ? 0.34 : Math.min(1.75, Math.max(0.6, 0.065 * w))),
      rp = isPole ? Math.min(1.2, Math.max(0.55, h / 40)) : desk ? 0.11 : Math.min(0.55, Math.max(0.16, (Hk || flagH * 1.25) / 330)),
      inner = null, x0, D = 1;
    if (isPole) { x0 = minX - rp - 0.9; D = Math.max(1, maxX - minX); }
    else {
      inner = chaikin(resample(insetPath(polePath(poly, shape), sw / 2), Math.max(0.25, Math.min(1.2, flagH / 120))), 2);
      x0 = inner[0][0];
      var dp = resample(inner, Math.max(0.5, flagH / 70));
      for (i = 0; i < poly.length; i++) {
        var dmin = Infinity;
        for (k = 0; k < dp.length - 1; k++) dmin = Math.min(dmin, segDist(poly[i], dp[k], dp[k + 1]));
        if (dmin > D && dmin < Infinity) D = dmin;
      }
    }
    // kit height and footprint, and where the flag sits (as buildKit)
    var top, foot, lawn = false;
    if (desk) { top = 1.2; foot = 2.8; }
    else if (kit === "ground-stake") { lawn = true; top = 9.3; foot = 4; }
    else if (kit === "cross-base" || kit === "cross-water") { top = 9.5; foot = 19; }
    else if (kit === "square-base") { top = 9.2; foot = 13; }
    else if (isPole) { lawn = true; top = 0.3; foot = 3; }
    else { top = 3; foot = 5; }
    var bottom, poleTop;
    if (isPole) {
      poleTop = flagH + Math.max(60, 1.5 * flagH) + Math.max(4, flagH * 0.08);
      bottom = poleTop - Math.max(3, flagH * 0.06) - flagH;
    } else {
      var clear = Math.max(top + (desk ? 1.5 : 8), desk ? 0.3 * flagH : 0);
      bottom = Hk ? Math.max(clear, Math.min(Hk - flagH, 0.4 * Hk)) : top + Math.max(desk ? 3 : 14, 0.2 * flagH);
      poleTop = bottom;
    }
    // framing box and home camera (as buildFlag's bounds, buildKit's framing points, homeView() and fitDistance())
    var zr = (isPole ? 0.125 : shape === "teardrop" || desk ? 0.126 : shape === "rectangle" ? 0.144 : 0.168) * D,
      bx0 = -rp * 2, bx1 = rp * 2;
    for (i = 0; i < poly.length; i++) { bx0 = Math.min(bx0, sx * (poly[i][0] - x0)); bx1 = Math.max(bx1, sx * (poly[i][0] - x0)); }
    var yTop = Math.max(poleTop + (isPole ? rp * 3.4 : 0), bottom + flagH),
      X0 = Math.min(bx0, -foot), X1 = Math.max(bx1, foot), Z0 = Math.min(-zr, -foot), Z1 = Math.max(zr * 0.6, foot),
      mx = (X0 + X1) / 2, my = yTop / 2, az = 0.5 * sx, el = 0.13, tv = Math.tan(FOV * PI / 360), th = tv * cw / ch,
      ca = Math.cos(az), sa = Math.sin(az), ce = Math.cos(el), se = Math.sin(el), r = 1;
    var cam = function (x, y, z) {
      x -= mx; y -= my;
      return [x * ca - z * sa, -x * se * sa + y * ce - z * se * ca, x * ce * sa + y * se + z * ce * ca];
    };
    for (i = 0; i < 8; i++) {
      p = cam(i & 1 ? X1 : X0, i & 2 ? yTop : 0, i & 4 ? Z1 : Z0);
      r = Math.max(r, p[2] + Math.max(Math.abs(p[0]) / FILL_HOME / th, Math.abs(p[1]) / FILL_HOME / tv));
    }
    var P = function (x, y, z) {
      var q = cam(x, y, z || 0), d = Math.max(1e-3, r - q[2]);
      return [(1 + q[0] / (d * th)) * cw / 2, (1 - q[1] / (d * tv)) * ch / 2];
    };
    var s0 = ch / 2 / (r * tv), C = { sleeve: "#1b1c1f", pole: "#34373c", silver: "#c4c9ce", alu: "#b9bec4", black: "#1f2124",
      plate: "#3e4248", bag: "#2a2d31", puck: "#cdd1d5", white: "#f2f2ef", brass: "#b89657" };
    // the ground disc as the camera sees it (perspective: points toward and away from the camera, and to its sides)
    var R = Math.max(desk ? 9 : 26, foot * 2.1, 0.3 * Math.max(isPole ? poleTop : bottom + flagH, 1)),
      gL = P(-ca * R, 0.02, sa * R), gR = P(ca * R, 0.02, -sa * R), gN = P(sa * R, 0.02, ca * R), gF = P(-sa * R, 0.02, -ca * R),
      ga = Math.max(2, Math.abs(gR[0] - gL[0]) / 2), gb = Math.max(1, Math.abs(gN[1] - gF[1]) / 2), ek = gb / ga,
      gc = [(gL[0] + gR[0]) / 2, (gN[1] + gF[1]) / 2];
    var cyl = function (rad, y0, y1, col, x, z) { // upright cylinder: body, then a lighter top
      var a = P(x || 0, y0, z || 0), b = P(x || 0, y1, z || 0), rw = Math.max(0.5, rad * s0), e = rw * ek,
        lg = g.createLinearGradient(a[0] - rw, 0, a[0] + rw, 0);
      lg.addColorStop(0, "rgba(0,0,0,0.22)"); lg.addColorStop(0.4, "rgba(255,255,255,0.18)"); lg.addColorStop(1, "rgba(0,0,0,0.3)");
      g.beginPath(); g.moveTo(a[0] - rw, a[1]); g.ellipse(a[0], a[1], rw, e, 0, PI, 0, true);
      g.lineTo(b[0] + rw, b[1]); g.ellipse(b[0], b[1], rw, e, 0, 0, PI, true); g.closePath();
      g.fillStyle = col; g.fill(); g.fillStyle = lg; g.fill();
      g.beginPath(); g.ellipse(b[0], b[1], rw, e, 0, 0, PI * 2); g.fillStyle = col; g.fill();
      g.fillStyle = "rgba(255,255,255,0.22)"; g.fill();
    };
    var bar = function (p0, p1, half, col) {
      var a = P(p0[0], p0[1], p0[2]), b = P(p1[0], p1[1], p1[2]);
      g.beginPath(); g.moveTo(a[0], a[1]); g.lineTo(b[0], b[1]);
      g.lineWidth = Math.max(1, half * 2 * s0); g.lineCap = "round"; g.strokeStyle = col; g.stroke();
    };
    g.setTransform(1, 0, 0, 1, 0, 0); g.globalAlpha = 1;
    g.fillStyle = bgColor(bg); g.fillRect(0, 0, cw, ch);
    // ground (lawn or floor) with the same soft fade as paintGround(), and the base's soft shadow
    var gcol = lawn ? "132,186,91" : desk ? "231,226,218" : "215,213,208";
    g.save(); g.translate(gc[0], gc[1]); g.scale(1, Math.max(0.02, ek));
    var gr = g.createRadialGradient(0, 0, 0, 0, 0, ga);
    gr.addColorStop(0, "rgba(" + gcol + ",1)"); gr.addColorStop(0.55, "rgba(" + gcol + ",1)");
    gr.addColorStop(0.78, "rgba(" + gcol + ",0.5)"); gr.addColorStop(0.96, "rgba(" + gcol + ",0)");
    g.fillStyle = gr; g.beginPath(); g.arc(0, 0, ga, 0, PI * 2); g.fill();
    var sr = Math.max(1.2, foot * 1.1) * ga / R, sg = g.createRadialGradient(0, 0, 0, 0, 0, sr);
    sg.addColorStop(0, "rgba(20,24,18,0.34)"); sg.addColorStop(1, "rgba(20,24,18,0)");
    g.fillStyle = sg; g.beginPath(); g.arc(0, 0, sr, 0, PI * 2); g.fill();
    g.restore();
    // base / kit (as buildKit, simplified)
    if (desk) { cyl(2.6, 0, 0.32, C.silver); cyl(0.32, 0.32, 1.4, C.silver); }
    else if (kit === "ground-stake") {
      cyl(0.42, -0.5, 9, C.alu); bar([-2.8, 1.6, 0], [2.8, 1.6, 0], 0.26, C.alu); cyl(rp * 1.35 + 0.08, 8.2, 9.6, C.black);
    } else if (kit === "cross-base" || kit === "cross-water") {
      if (kit === "cross-water") cyl(13.2, 0.1, 5.1, C.bag);
      var legs = [];
      for (k = 0; k < 4; k++) { var an = PI / 4 + k * PI / 2; legs.push([Math.cos(an), -Math.sin(an), cam(Math.cos(an) * 18, 0, -Math.sin(an) * 18)[2]]); }
      legs.sort(function (a, b) { return a[2] - b[2]; });
      for (k = 0; k < 4; k++) {
        bar([legs[k][0] * 1.2, 3.2, legs[k][1] * 1.2], [legs[k][0] * 18.2, 0.6, legs[k][1] * 18.2], 0.5, C.alu);
        cyl(0.75, 0, 0.6, C.black, legs[k][0] * 18.2, legs[k][1] * 18.2);
      }
      cyl(1.25, 1.6, 4.4, C.alu); cyl(0.36, 4.4, 9.25, C.silver); cyl(rp * 1.35 + 0.08, 8.5, 9.8, C.black);
    } else if (kit === "square-base") {
      g.beginPath(); [[-9, -9], [9, -9], [9, 9], [-9, 9]].forEach(function (q, j) { var t = P(q[0], 0.55, q[1]); if (j) g.lineTo(t[0], t[1]); else g.moveTo(t[0], t[1]); });
      g.closePath(); g.fillStyle = C.plate; g.fill();
      cyl(1.4, 0.55, 1.6, C.plate); cyl(0.36, 1.6, 9, C.silver); cyl(rp * 1.35 + 0.08, 8.2, 9.5, C.black);
    } else if (isPole) { cyl(rp + 1.5, 0, 0.6, C.puck); }
    else { cyl(4.6, 0, 1.4, C.puck); cyl(rp + 0.7, 1.4, 3.2, C.puck); }
    // pole
    if (isPole) {
      cyl(rp, top, poleTop, C.silver);
      var fp = P(0, poleTop + rp * 1.6, 0), fr = Math.max(1, rp * 1.9 * s0), fg = g.createRadialGradient(fp[0] - fr * 0.35, fp[1] - fr * 0.35, 0, fp[0], fp[1], fr);
      fg.addColorStop(0, "#efe0b8"); fg.addColorStop(1, C.brass);
      g.beginPath(); g.arc(fp[0], fp[1], fr, 0, PI * 2); g.fillStyle = fg; g.fill();
    } else cyl(rp, top - 0.5, bottom + 1, shape === "rectangle" || desk ? C.silver : C.pole);
    // the flag: the front face picture, cut to the outline (texture (u, v) -> world (A0 + u * w, yb - v * h, 0), as the 3D uv map)
    var A0 = sx > 0 ? -x0 : x0 - w, yb = bottom + maxY, pO = P(A0, yb, 0), pU = P(A0 + w, yb, 0), pV = P(A0, yb - h, 0);
    g.save();
    g.setTransform((pU[0] - pO[0]) / w, (pU[1] - pO[1]) / w, (pV[0] - pO[0]) / h, (pV[1] - pO[1]) / h, pO[0], pO[1]);
    g.beginPath();
    for (i = 0; i < poly.length; i++) { var ox = sx < 0 ? w - poly[i][0] : poly[i][0]; if (i) g.lineTo(ox, poly[i][1]); else g.moveTo(ox, poly[i][1]); }
    g.closePath(); g.fillStyle = C.white; g.fill(); g.clip();
    if (face && face.width > 0 && face.height > 0) { try { g.drawImage(face, 0, 0, w, h); } catch (e) { } }
    var sh = g.createLinearGradient(sx > 0 ? 0 : w, 0, sx > 0 ? w : 0, 0), pv = Math.sqrt(Math.pow(pV[0] - pO[0], 2) + Math.pow(pV[1] - pO[1], 2)) / h;
    sh.addColorStop(0, "rgba(0,0,0,0.02)"); sh.addColorStop(0.6, "rgba(0,0,0,0.07)"); sh.addColorStop(1, "rgba(0,0,0,0.2)");
    g.fillStyle = sh; g.fillRect(0, 0, w, h); // soft light falloff toward the free edge, like the 3D view
    g.lineWidth = 2 / Math.max(1e-3, pv); g.strokeStyle = "rgba(0,0,0,0.14)"; g.stroke();
    g.restore();
    if (inner) { // sleeve along the attached edge
      g.beginPath();
      for (i = 0; i < inner.length; i++) { p = P(sx * (inner[i][0] - x0), yb - inner[i][1], 0); if (i) g.lineTo(p[0], p[1]); else g.moveTo(p[0], p[1]); }
      g.lineWidth = Math.max(1, 2 * Math.max(rp * 1.18, sw * 0.56) * s0); g.lineCap = "round"; g.lineJoin = "round";
      g.strokeStyle = C.sleeve; g.stroke();
    } else { // pole flag header strip
      var hw = Math.min(sw, w * 0.06), e0 = sx * (minX - x0), e1 = sx * (minX - x0 + hw);
      g.beginPath(); [[e0, bottom], [e1, bottom], [e1, bottom + flagH], [e0, bottom + flagH]].forEach(function (q, j) { var t = P(q[0], q[1], 0); if (j) g.lineTo(t[0], t[1]); else g.moveTo(t[0], t[1]); });
      g.closePath(); g.fillStyle = C.white; g.fill(); g.lineWidth = 1; g.strokeStyle = "rgba(0,0,0,0.12)"; g.stroke();
    }
    return true;
  }

  /* ---------- viewer ---------- */
  function build(host, opts) {
    var THREE = root.THREE, doc = host.ownerDocument || document, win = doc.defaultView || root,
      bg = bgColor(opts.background), canvas = doc.createElement("canvas");
    canvas.setAttribute("aria-label", "3D preview of your flag. Drag to turn it.");
    canvas.setAttribute("data-ardor-flag3d", "init");
    canvas.style.cssText = "position:absolute;top:0;left:0;right:0;bottom:0;inset:0;width:100%;height:100%;display:block;touch-action:none;outline:none;cursor:grab;";
    var attrs = { alpha: false, antialias: true, depth: true, stencil: false, premultipliedAlpha: true, preserveDrawingBuffer: false },
      gl = null;
    try { gl = canvas.getContext("webgl2", attrs); } catch (e1) { gl = null; }
    if (!gl) try { gl = canvas.getContext("webgl", attrs) || canvas.getContext("experimental-webgl", attrs); } catch (e2) { gl = null; }
    if (!gl) return null;
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, context: gl, antialias: true, alpha: false, stencil: false, preserveDrawingBuffer: false });
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.NoToneMapping;
    renderer.setClearColor(new THREE.Color(bg), 1);
    try { if (win.getComputedStyle && win.getComputedStyle(host).position === "static") host.style.position = "relative"; } catch (e3) { }
    host.appendChild(canvas);

    var maxAniso = 1;
    try { maxAniso = renderer.capabilities.getMaxAnisotropy() || 1; } catch (e4) { maxAniso = 1; }
    var canMip = !!renderer.capabilities.isWebGL2, scene = new THREE.Scene(),
      camera = new THREE.PerspectiveCamera(FOV, 1, 1, 4000), disposed = false;
    scene.add(camera);

    function lin(hex) { var c = new THREE.Color(hex); c.convertSRGBToLinear(); return c; }
    // lights: soft sky/ground fill, a light that follows the camera (so every side reads), a weak fixed sun
    var hemi = new THREE.HemisphereLight(lin("#ffffff"), lin("#c9c4ba"), 0.5);
    hemi.position.set(0, 1, 0);
    scene.add(hemi);
    var head = new THREE.DirectionalLight(0xffffff, 0.32);
    head.position.set(-0.3, 0.5, 1);
    camera.add(head); camera.add(head.target);
    var SUN = [-0.32, 1, 0.42], key = new THREE.DirectionalLight(0xffffff, 0.4), fill = new THREE.DirectionalLight(0xffffff, 0.28);
    key.position.set(-0.45, 0.55, 0.7); fill.position.set(0.4, 0.5, -0.75);
    scene.add(key); scene.add(fill);

    /* materials (kept for the life of the viewer) */
    var U = { flip: { value: 0 }, mute: { value: 1 } }, U0 = { flip: { value: 0 }, mute: { value: 0 } };
    function clothMat(side, u, tag) {
      var m = new THREE.MeshLambertMaterial({ color: 0xffffff, side: side });
      m.onBeforeCompile = function (sh) {
        sh.uniforms.uFlip = u.flip; sh.uniforms.uMute = u.mute;
        sh.fragmentShader = sh.fragmentShader.replace("#include <common>", "#include <common>\nuniform float uFlip;\nuniform float uMute;")
          .replace("#include <map_fragment>", [
            "#ifdef USE_MAP",
            "  vec4 tc = texture2D( map, vec2( mix( vUv.x, 1.0 - vUv.x, uFlip ), vUv.y ) );",
            "  tc.rgb = mix( vec3( 1.0 ), tc.rgb, tc.a );",
            "  float lum = dot( tc.rgb, vec3( 0.2126, 0.7152, 0.0722 ) );",
            "  tc.rgb = mix( tc.rgb, vec3( lum ), 0.35 * uMute );",
            "  tc.rgb = mix( tc.rgb, vec3( 1.0 ), 0.22 * uMute );",
            "  diffuseColor.rgb *= tc.rgb;",
            "#endif"].join("\n"));
      };
      m.customProgramCacheKey = function () { return tag; };
      return m;
    }
    var frontMat = clothMat(THREE.FrontSide, U0, "ardorFlagFront"), backMat = clothMat(THREE.BackSide, U, "ardorFlagBack");
    function lam(hex) { return new THREE.MeshLambertMaterial({ color: lin(hex) }); }
    function metal(hex, shin) { return new THREE.MeshPhongMaterial({ color: lin(hex), specular: lin("#5a5f66"), shininess: shin || 60 }); }
    var M = {
      sleeve: lam("#1b1c1f"), pole: metal("#34373c", 40), silver: metal("#c4c9ce", 70), alu: metal("#b9bec4", 55),
      black: lam("#1f2124"), plate: metal("#3e4248", 30), bag: metal("#2a2d31", 18), puck: lam("#cdd1d5"),
      white: lam("#f2f2ef"), brass: metal("#b89657", 80), cord: lam("#202124")
    };
    M.bag.side = THREE.DoubleSide;
    var groundMat = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, depthWrite: false, toneMapped: false });

    function plainTexture(c) {
      var t = new THREE.CanvasTexture(c);
      t.encoding = THREE.sRGBEncoding;
      t.anisotropy = maxAniso;
      t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
      t.magFilter = THREE.LinearFilter;
      t.minFilter = canMip ? THREE.LinearMipmapLinearFilter : THREE.LinearFilter;
      t.generateMipmaps = canMip;
      return t;
    }
    var groundCv = doc.createElement("canvas");
    groundCv.width = groundCv.height = 1024;
    var groundTex = plainTexture(groundCv);
    groundMat.map = groundTex;

    var placeCv = doc.createElement("canvas"), placeTex = null, placeKey = "";
    function placeholder() {
      var w = state.w, h = state.h, k = Math.min(1024 / Math.max(w, h), 40), cw = Math.max(8, Math.round(w * k)),
        ch = Math.max(8, Math.round(h * k)), key = cw + "x" + ch;
      if (placeTex && key === placeKey) return placeTex;
      placeKey = key;
      if (placeTex) placeTex.dispose();
      placeCv.width = cw; placeCv.height = ch;
      var g = placeCv.getContext("2d"), tall = ch > cw * 1.6, fs = Math.round((tall ? ch : cw) * 0.055);
      g.fillStyle = "#ffffff"; g.fillRect(0, 0, cw, ch);
      g.save(); g.translate(cw / 2, ch / 2); if (tall) g.rotate(-PI / 2);
      g.fillStyle = "#a6abb2"; g.textAlign = "center"; g.textBaseline = "middle";
      g.font = "600 " + fs + "px Helvetica, Arial, sans-serif";
      g.fillText("Your artwork goes here", 0, 0);
      g.restore();
      placeTex = plainTexture(placeCv);
      return placeTex;
    }

    var faces = { front: { src: null, tex: null, w: 0, h: 0 }, back: { src: null, tex: null, w: 0, h: 0 } },
      state = { key: "", shape: "feather-angled", w: 28, h: 138, outline: null, ohash: "none", sleeve: "left", sides: 1, kit: "ground-stake", height: null, sleeveW: null },
      flagRoot = null, kitRoot = null, flagGeos = [], kitGeos = [], cloth = null, info = null,
      ground = null, ptsAll = [], ptsFlag = [], cAll = new THREE.Vector3(), cFlag = new THREE.Vector3(),
      target = new THREE.Vector3(0, 60, 0), fitHome = 300, size = { w: 0, h: 0 }, clothKey = "", kitKey = "",
      VIEWS = { home: { az: 0.5, el: 0.13 }, front: { az: 0, el: 0.07 }, back: { az: PI, el: 0.07 }, side: { az: 1.0, el: 0.1 }, left: { az: -1.0, el: 0.1 }, right: { az: 1.0, el: 0.1 } };

    function bindTextures() {
      var front = faces.front.tex || placeholder();
      frontMat.map = front;
      if (state.sides === 2) { backMat.map = faces.back.tex || front; U.flip.value = 1; U.mute.value = 0; }
      else { backMat.map = front; U.flip.value = 0; U.mute.value = 1; }
    }
    function applyTexture(face) {
      var f = faces[face], src = f.src;
      if (!src || !(src.width > 0) || !(src.height > 0)) {
        if (f.tex) f.tex.dispose();
        f.tex = null; f.w = f.h = 0;
      } else if (f.tex && f.tex.image === src && f.w === src.width && f.h === src.height) {
        f.tex.needsUpdate = true;
      } else {
        if (f.tex) f.tex.dispose();
        f.tex = plainTexture(src); f.w = src.width; f.h = src.height;
      }
      bindTextures();
    }

    var controls = new THREE.OrbitControls(camera, canvas);
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.dampingFactor = 0.12;
    controls.rotateSpeed = 0.8;
    controls.zoomSpeed = 0.9;
    controls.minPolarAngle = PI / 2 - EL_MAX;
    controls.maxPolarAngle = PI / 2 - EL_MIN;

    /* ---------- model building ---------- */
    function addTo(group, list, geo, mat, x, y, z) {
      var m = new THREE.Mesh(geo, mat);
      m.position.set(x || 0, y || 0, z || 0);
      group.add(m); list.push(geo);
      return m;
    }
    function cyl(group, list, mat, r0, r1, y0, y1, x, z, seg) {
      return addTo(group, list, new THREE.CylinderGeometry(r1, r0, y1 - y0, seg || 16), mat, x, (y0 + y1) / 2, z);
    }
    function between(group, list, mat, r, a, b) { // a thin cylinder from point a to point b
      var va = new THREE.Vector3(a[0], a[1], a[2]), vb = new THREE.Vector3(b[0], b[1], b[2]), L = va.distanceTo(vb),
        m = addTo(group, list, new THREE.CylinderGeometry(r, r, L, 8), mat);
      m.position.copy(va).add(vb).multiplyScalar(0.5);
      m.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), vb.sub(va).normalize());
      return m;
    }
    function disposeList(list) { for (var i = 0; i < list.length; i++) try { list[i].dispose(); } catch (e) { } list.length = 0; }

    function buildFlag() {
      if (flagRoot) { scene.remove(flagRoot); disposeList(flagGeos); }
      flagRoot = new THREE.Group();
      scene.add(flagRoot);
      var w = state.w, h = state.h, shape = state.shape, isPole = shape === "pole-flag", desk = shape === "teardrop-desk",
        sx = state.sleeve === "right" ? -1 : 1, src = state.outline, poly = [], i, k;
      // canonical space: pole edge on the left (a given outline is mirrored when the sleeve is on the right)
      if (src) for (i = 0; i < src.length; i++) poly.push([sx < 0 ? w - src[i][0] : src[i][0], src[i][1]]);
      else poly = defaultOutline(shape, w, h);
      var mesh = clothMesh(THREE, poly, desk ? 900 : 2600), minX = mesh.minX, maxX = mesh.maxX, minY = mesh.minY, maxY = mesh.maxY,
        sw = state.sleeveW || (isPole ? Math.min(2, Math.max(0.6, 0.035 * h)) : desk ? 0.34 : Math.min(1.75, Math.max(0.6, 0.065 * w))),
        Hk = state.height || HEIGHTS[state.key] || 0, rp, path = null, inner = null, x0, flagH = maxY - minY;
      rp = isPole ? Math.min(1.2, Math.max(0.55, h / 40)) : desk ? 0.11 : Math.min(0.55, Math.max(0.16, (Hk || flagH * 1.25) / 330));
      if (isPole) {
        x0 = minX - rp - 0.9;
      } else {
        path = polePath(poly, shape);
        inner = chaikin(resample(insetPath(path, sw / 2), Math.max(0.25, Math.min(1.2, flagH / 120))), 2);
        x0 = inner[0][0];
      }
      // per vertex: world position, uv, distance to the attached edge
      var nv = mesh.xs.length, pos = new Float32Array(nv * 3), nrm = new Float32Array(nv * 3), uv = new Float32Array(nv * 2),
        dd = new Float32Array(nv), gx = new Float32Array(nv), gy = new Float32Array(nv), cyA = new Float32Array(nv), D = 1,
        dpath = inner ? resample(inner, Math.max(0.5, flagH / 70)) : null;
      for (i = 0; i < nv; i++) {
        var x = mesh.xs[i], y = mesh.ys[i], d, ux = 1, uy = 0;
        pos[i * 3] = sx * (x - x0); pos[i * 3 + 1] = maxY - y; pos[i * 3 + 2] = 0;
        uv[i * 2] = (sx < 0 ? w - x : x) / w; uv[i * 2 + 1] = 1 - y / h;
        nrm[i * 3 + 2] = 1;
        if (isPole) { d = Math.max(0, x - minX); }
        else {
          d = Infinity;
          for (k = 0; k < dpath.length - 1; k++) {
            var a = dpath[k], b = dpath[k + 1], ex = b[0] - a[0], ey = b[1] - a[1], L2 = ex * ex + ey * ey,
              t = L2 > 0 ? Math.max(0, Math.min(1, ((x - a[0]) * ex + (y - a[1]) * ey) / L2)) : 0,
              qx = x - a[0] - ex * t, qy = y - a[1] - ey * t, dq = qx * qx + qy * qy;
            if (dq < d) { d = dq; ux = qx; uy = qy; }
          }
          d = Math.sqrt(d);
          if (d > 1e-6) { ux /= d; uy /= d; } else { ux = 1; uy = 0; }
        }
        dd[i] = d; gx[i] = ux; gy[i] = uy; cyA[i] = y;
        if (d > D) D = d;
      }
      var idx = mesh.idx;
      for (i = 0; i < idx.length; i += 3) { // every triangle faces +z
        var p0 = idx[i] * 3, p1 = idx[i + 1] * 3, p2 = idx[i + 2] * 3,
          cr = (pos[p1] - pos[p0]) * (pos[p2 + 1] - pos[p0 + 1]) - (pos[p1 + 1] - pos[p0 + 1]) * (pos[p2] - pos[p0]);
        if (cr < 0) { k = idx[i + 1]; idx[i + 1] = idx[i + 2]; idx[i + 2] = k; }
      }
      var geo = new THREE.BufferGeometry();
      geo.setAttribute("position", new THREE.BufferAttribute(pos, 3));
      geo.setAttribute("normal", new THREE.BufferAttribute(nrm, 3));
      geo.setAttribute("uv", new THREE.BufferAttribute(uv, 2));
      geo.setIndex(nv > 65000 ? new THREE.Uint32BufferAttribute(idx, 1) : new THREE.Uint16BufferAttribute(idx, 1));
      geo.attributes.position.setUsage(THREE.DynamicDrawUsage);
      geo.attributes.normal.setUsage(THREE.DynamicDrawUsage);
      var fm = addTo(flagRoot, flagGeos, geo, frontMat), bm = new THREE.Mesh(geo, backMat);
      flagRoot.add(bm);
      fm.frustumCulled = bm.frustumCulled = false;
      // wind shape per flag type
      var wk = isPole ? [0.03, 0.045, 0.05, 0.55, 1.6] : shape === "teardrop" || desk ? [0.07, 0.026, 0.03, 1.0, 3] :
        shape === "rectangle" ? [0.08, 0.03, 0.034, 1.0, 3] : [0.1, 0.032, 0.036, 1.05, 3.2];
      var wp = {
        D: D, B: wk[0] * D, As: wk[1] * D, Ad: wk[2] * D, p: 1.7, q: 1.2,
        k1: 2 * PI / (wk[3] * D), ky1: 2 * PI / (wk[4] * D), f1: 0.7,
        k2: 2 * PI / (0.9 * wk[3] * D), ky2: 2 * PI / (1.3 * wk[4] * D), o2: 2 * PI * (isPole ? 0.7 : 0.45),
        k3: 2 * PI / (0.55 * wk[3] * D), ky3: 2 * PI / (0.8 * wk[4] * D), o3: 2 * PI * (isPole ? 1.1 : 0.75)
      };
      cloth = { geo: geo, pos: pos, nrm: nrm, d: dd, gx: gx, gy: gy, cy: cyA, n: nv, sx: sx, wp: wp };
      var zr = wp.B + wp.As + wp.Ad;
      // sleeve tube along the attached edge, or the pole flag header
      var pts3 = [], topY = maxY - minY;
      if (!isPole) {
        for (i = 0; i < inner.length; i++) pts3.push(new THREE.Vector3(sx * (inner[i][0] - x0), maxY - inner[i][1], 0));
        var curve = new THREE.CatmullRomCurve3(pts3, false, "centripetal"), plen = curve.getLength(),
          rs = Math.max(rp * 1.18, sw * 0.56);
        addTo(flagRoot, flagGeos, new THREE.TubeGeometry(curve, Math.max(16, Math.min(280, Math.round(plen / Math.max(0.12, flagH / 110)))), rs, 10, false), M.sleeve);
        var cap = new THREE.SphereGeometry(rs, 10, 8);
        flagGeos.push(cap);
        var c0 = new THREE.Mesh(cap, M.sleeve), c1 = new THREE.Mesh(cap, M.sleeve);
        c0.position.copy(pts3[0]); c1.position.copy(pts3[pts3.length - 1]);
        flagRoot.add(c0); flagRoot.add(c1);
        if (shape === "teardrop" || desk) { // bungee cord from the bottom tip down to the base ring
          info = { cordFrom: [sx * (path[0][0] - x0 + sw * 0.9), maxY - path[0][1] + sw * 0.4, 0] };
        } else info = {};
      } else {
        var hw = Math.min(sw, w * 0.06), hg = new THREE.BoxGeometry(hw, flagH, 0.14);
        addTo(flagRoot, flagGeos, hg, M.white, sx * (minX - x0 + hw / 2), flagH / 2, 0);
        var gr = new THREE.TorusGeometry(Math.max(0.28, hw * 0.28), Math.max(0.07, hw * 0.08), 6, 14), gy0 = [flagH - hw * 0.7, hw * 0.7];
        flagGeos.push(gr);
        for (k = 0; k < 2; k++) {
          var gxw = sx * (minX - x0 + hw / 2), gm1 = new THREE.Mesh(gr, M.brass);
          gm1.position.set(gxw, gy0[k], 0);
          flagRoot.add(gm1);
          between(flagRoot, flagGeos, M.cord, 0.09, [gxw, gy0[k], 0], [0, gy0[k] + (k ? -1.2 : 1.2), 0]);
        }
        var ring = new THREE.TorusGeometry(rp + 0.12, 0.1, 6, 18);
        flagGeos.push(ring);
        for (k = 0; k < 2; k++) {
          var rm = new THREE.Mesh(ring, M.alu);
          rm.rotation.x = PI / 2; rm.position.set(0, gy0[k] + (k ? -1.2 : 1.2), 0);
          flagRoot.add(rm);
        }
        info = {};
      }
      // flag bounds (local, before lifting onto its base)
      var bx0 = Infinity, bx1 = -Infinity;
      for (i = 0; i < nv; i++) { bx0 = Math.min(bx0, pos[i * 3]); bx1 = Math.max(bx1, pos[i * 3]); }
      bx0 = Math.min(bx0, -rp * 2); bx1 = Math.max(bx1, rp * 2);
      info.box = [bx0, 0, -zr, bx1, topY, zr * 0.6];
      info.rp = rp; info.Hk = Hk; info.flagH = flagH; info.isPole = isPole; info.desk = desk; info.sx = sx;
      info.x0 = x0;
      // ground shadow outline (local x, y)
      info.shadow = [];
      for (i = 0; i < poly.length; i++) info.shadow.push([sx * (poly[i][0] - x0), maxY - poly[i][1]]);
      poseCloth(wind.t, wind.level);
    }

    function buildKit() {
      if (kitRoot) { scene.remove(kitRoot); disposeList(kitGeos); }
      kitRoot = new THREE.Group();
      scene.add(kitRoot);
      var G = kitRoot, L = kitGeos, kit = state.kit, rp = info.rp, top = 0, foot = 6, lawn = false, desk = info.desk, i, k;
      if (desk) {
        cyl(G, L, M.silver, 2.6, 2.5, 0, 0.32, 0, 0, 40);
        cyl(G, L, M.silver, 0.32, 0.24, 0.32, 1.4, 0, 0, 16);
        top = 1.2; foot = 2.8;
      } else if (kit === "ground-stake") {
        lawn = true;
        cyl(G, L, M.alu, 0.42, 0.42, -0.5, 9, 0, 0, 16);
        between(G, L, M.alu, 0.26, [-2.8, 1.6, 0], [2.8, 1.6, 0]);
        cyl(G, L, M.black, rp * 1.35 + 0.08, rp * 1.35 + 0.08, 8.2, 9.6, 0, 0, 16);
        top = 9.3; foot = 4;
      } else if (kit === "cross-base" || kit === "cross-water") {
        cyl(G, L, M.alu, 1.25, 1.25, 1.6, 4.4, 0, 0, 20);
        for (k = 0; k < 4; k++) {
          var an = PI / 4 + k * PI / 2, ca = Math.cos(an), sa = Math.sin(an), lg = new THREE.BoxGeometry(17.6, 0.55, 1.0),
            lm = addTo(G, L, lg, M.alu);
          lm.position.set(ca * 9.6, 1.85, -sa * 9.6);
          lm.rotation.set(0, an, Math.atan2(-2.6, 17.6) * 1);
          lm.rotation.order = "YZX";
          cyl(G, L, M.black, 0.75, 0.75, 0, 0.6, ca * 18.2, -sa * 18.2, 12);
        }
        cyl(G, L, M.silver, 0.36, 0.36, 4.4, 9.25, 0, 0, 12);
        cyl(G, L, M.black, rp * 1.35 + 0.08, rp * 1.35 + 0.08, 8.5, 9.8, 0, 0, 16);
        top = 9.5; foot = 19;
        if (kit === "cross-water") {
          var prof = [], n = 24;
          for (i = 0; i <= n; i++) {
            var t = -PI / 2 + (i / n) * 2 * PI;
            prof.push(new THREE.Vector2(8.3 + 4.9 * Math.cos(t), 2.6 + 2.5 * Math.sin(t)));
          }
          addTo(G, L, new THREE.LatheGeometry(prof, 40), M.bag, 0, 0.5, 0);
          cyl(G, L, M.bag, 0.9, 0.9, 5.4, 6.4, 7.5, 7.5, 12);
          foot = 19;
        }
      } else if (kit === "square-base") {
        addTo(G, L, new THREE.BoxGeometry(18, 0.55, 18), M.plate, 0, 0.275, 0);
        cyl(G, L, M.plate, 1.4, 1.2, 0.55, 1.6, 0, 0, 20);
        cyl(G, L, M.silver, 0.36, 0.36, 1.6, 9, 0, 0, 12);
        cyl(G, L, M.black, rp * 1.35 + 0.08, rp * 1.35 + 0.08, 8.2, 9.5, 0, 0, 16);
        top = 9.2; foot = 13;
      } else if (info.isPole) {
        lawn = true;
        cyl(G, L, M.puck, rp + 1.3, rp + 1.5, 0, 0.6, 0, 0, 24);
        top = 0.3; foot = 3;
      } else { // flag only: shown on its pole in a plain neutral stand
        cyl(G, L, M.puck, 4.3, 4.6, 0, 1.4, 0, 0, 32);
        cyl(G, L, M.puck, rp + 0.5, rp + 0.7, 1.4, 3.2, 0, 0, 20);
        top = 3; foot = 5;
      }
      // where the flag sits
      var flagH = info.flagH, bottom, poleTop;
      if (info.isPole) {
        poleTop = flagH + Math.max(60, 1.5 * flagH) + Math.max(4, flagH * 0.08);
        bottom = poleTop - Math.max(3, flagH * 0.06) - flagH;
        var fin = new THREE.SphereGeometry(rp * 1.9, 16, 12);
        addTo(G, L, fin, M.brass, 0, poleTop + rp * 1.6, 0);
        cyl(G, L, M.silver, rp, rp, top, poleTop, 0, 0, 20);
      } else {
        var clear = Math.max(top + (desk ? 1.5 : 8), desk ? 0.3 * flagH : 0);
        bottom = info.Hk ? Math.max(clear, Math.min(info.Hk - flagH, 0.4 * info.Hk)) : top + Math.max(desk ? 3 : 14, 0.2 * flagH);
        poleTop = bottom;
        var poleMat = state.shape === "rectangle" || desk ? M.silver : M.pole;
        cyl(G, L, poleMat, info.rp, info.rp * 0.92, top - 0.5, bottom + 1, 0, 0, 16);
        if (info.cordFrom) {
          var cf = info.cordFrom;
          between(G, L, M.cord, desk ? 0.04 : 0.11, [cf[0], cf[1] + bottom, 0], [info.sx * (rp + 0.25), top + (desk ? 0.4 : 1.2), 0]);
        }
      }
      flagRoot.position.y = bottom;
      info.bottom = bottom; info.top = poleTop; info.foot = foot; info.lawn = lawn; info.kitTop = top;
      paintGround();
      // framing points
      var b = info.box, ys = [0, bottom + b[4], Math.max(poleTop + (info.isPole ? rp * 3.4 : 0), bottom + b[4])];
      ptsAll = []; ptsFlag = [];
      var X0 = Math.min(b[0], -foot), X1 = Math.max(b[3], foot), Z0 = Math.min(b[2], -foot), Z1 = Math.max(b[5], foot), yTop = ys[2];
      for (i = 0; i < 8; i++) {
        ptsAll.push(new THREE.Vector3(i & 1 ? X1 : X0, i & 2 ? yTop : 0, i & 4 ? Z1 : Z0));
        ptsFlag.push(new THREE.Vector3(i & 1 ? b[3] : b[0], i & 2 ? bottom + b[4] : bottom, i & 4 ? b[5] : b[2]));
      }
      cAll.set((X0 + X1) / 2, yTop / 2, 0);
      cFlag.set((b[0] + b[3]) / 2, bottom + b[4] / 2, 0);
      var big = Math.max(yTop, X1 - X0);
      camera.near = Math.max(0.2, big / 150); camera.far = big * 30;
      camera.updateProjectionMatrix();
    }

    function paintGround() {
      var N = groundCv.width, g = groundCv.getContext("2d"), H = info.top + info.flagH, kit = state.kit,
        R = Math.max(info.desk ? 9 : 26, info.foot * 2.1, 0.3 * Math.max(info.isPole ? info.top : info.bottom + info.flagH, 1)),
        s = N / (2 * R), rnd = rng(7), i, x, y, a, r;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.globalCompositeOperation = "source-over";
      g.shadowColor = "rgba(0,0,0,0)"; g.shadowBlur = 0;
      g.clearRect(0, 0, N, N);
      if (info.lawn) {
        g.fillStyle = "#84ba5b"; g.fillRect(0, 0, N, N);
        var gs = Math.max(0.6, Math.min(3, s * 0.4));
        for (i = 0; i < 9000; i++) {
          a = rnd() * PI * 2; r = Math.sqrt(rnd()) * N / 2; x = N / 2 + Math.cos(a) * r; y = N / 2 + Math.sin(a) * r;
          g.fillStyle = i % 2 ? "rgba(108,164,72,0.32)" : "rgba(156,204,112,0.32)";
          g.fillRect(x, y, gs * (1 + rnd()), gs * (2 + rnd() * 3));
        }
      } else {
        g.fillStyle = info.desk ? "#e7e2da" : "#d7d5d0"; g.fillRect(0, 0, N, N);
        for (i = 0; i < 7000; i++) {
          g.fillStyle = rnd() > 0.5 ? "rgba(255,255,255,0.35)" : "rgba(90,88,84,0.16)";
          g.fillRect(rnd() * N, rnd() * N, 1 + rnd() * 1.5, 1 + rnd() * 1.5);
        }
        if (!info.desk) { // expansion joints
          g.strokeStyle = "rgba(120,116,110,0.22)"; g.lineWidth = Math.max(1, s * 0.25);
          var jstep = 48 * s, off = N / 2 + 30 * s;
          for (x = off % jstep; x < N; x += jstep) { g.beginPath(); g.moveTo(x, 0); g.lineTo(x, N); g.stroke(); }
          for (y = off % jstep; y < N; y += jstep) { g.beginPath(); g.moveTo(0, y); g.lineTo(N, y); g.stroke(); }
        }
      }
      // soft shadows: flag, pole, base footprint
      var OFF = N * 3, lx = SUN[0] / SUN[1], lz = SUN[2] / SUN[1];
      function P(X, Y, Z) { return [N / 2 + (X - lx * Y) * s - OFF, N / 2 + (Z - lz * Y) * s]; }
      function shade(alpha, blur, draw) {
        g.save(); g.shadowColor = "rgba(20,24,18," + alpha + ")"; g.shadowBlur = Math.max(1, blur); g.shadowOffsetX = OFF;
        g.fillStyle = "#000"; g.strokeStyle = "#000"; g.beginPath(); draw(); g.restore();
      }
      var sh = info.shadow, bt = info.bottom;
      shade(0.16, Math.max(6, s * 2.5), function () {
        for (i = 0; i < sh.length; i++) { var q = P(sh[i][0], sh[i][1] + bt, 0); if (i) g.lineTo(q[0], q[1]); else g.moveTo(q[0], q[1]); }
        g.closePath(); g.fill();
      });
      shade(0.22, Math.max(3, s * 1.2), function () {
        var q0 = P(0, 0, 0), q1 = P(0, info.isPole ? info.top : bt + 2, 0);
        g.lineWidth = Math.max(1.5, info.rp * 2 * s); g.moveTo(q0[0], q0[1]); g.lineTo(q1[0], q1[1]); g.stroke();
      });
      shade(0.32, Math.max(4, s * 1.5), function () {
        var q = P(0, 0, 0);
        if (kit === "square-base" && !info.desk) { g.rect(q[0] - 9.3 * s, q[1] - 9.3 * s, 18.6 * s, 18.6 * s); g.fill(); }
        else if ((kit === "cross-base" || kit === "cross-water") && !info.desk) {
          g.lineWidth = 1.3 * s;
          for (var k = 0; k < 4; k++) { var an = PI / 4 + k * PI / 2; g.moveTo(q[0], q[1]); g.lineTo(q[0] + Math.cos(an) * 18.4 * s, q[1] + Math.sin(an) * 18.4 * s); }
          g.stroke();
          if (kit === "cross-water") { g.beginPath(); g.arc(q[0], q[1], 13.2 * s, 0, PI * 2); g.fill(); }
        } else { g.arc(q[0], q[1], Math.max(1.2, info.foot * 0.75) * s, 0, PI * 2); g.fill(); }
      });
      var fade = g.createRadialGradient(N / 2, N / 2, 0, N / 2, N / 2, N / 2);
      fade.addColorStop(0, "rgba(0,0,0,1)"); fade.addColorStop(0.55, "rgba(0,0,0,1)"); fade.addColorStop(0.78, "rgba(0,0,0,0.5)");
      fade.addColorStop(0.96, "rgba(0,0,0,0)"); fade.addColorStop(1, "rgba(0,0,0,0)");
      g.globalCompositeOperation = "destination-in"; g.fillStyle = fade; g.fillRect(0, 0, N, N);
      g.globalCompositeOperation = "source-over";
      groundTex.needsUpdate = true;
      if (!ground) {
        ground = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), groundMat);
        ground.rotation.x = -PI / 2; ground.renderOrder = -1;
        scene.add(ground);
      }
      ground.scale.set(R, R, 1);
      ground.position.y = 0.02;
    }

    /* ---------- wind ---------- */
    var idleMs = num(opts.idle, 0, 600000), wind = { on: opts.wind !== false, t: 3.1, level: 0, last: 0, until: 0 }, reduced = false, onScreen = true, mq = null, io = null;
    try { mq = win.matchMedia ? win.matchMedia("(prefers-reduced-motion: reduce)") : null; reduced = !!(mq && mq.matches); } catch (e5) { mq = null; }
    function windWanted() { return wind.on && !reduced && onScreen && !doc.hidden && size.w > 40 && now() < wind.until; }
    function wake() { wind.until = now() + (idleMs === null ? IDLE_MS : idleMs); invalidate(); }
    function poseCloth(t, m) {
      if (!cloth) return;
      var P = cloth.pos, Nn = cloth.nrm, d = cloth.d, gx = cloth.gx, gy = cloth.gy, cy = cloth.cy, w = cloth.wp, sx = cloth.sx, n = cloth.n, i;
      for (i = 0; i < n; i++) {
        var u = Math.min(1, d[i] / w.D), y = cy[i], up = Math.pow(u, w.p), uq = Math.pow(u, w.q),
          dup = u > 1e-6 ? w.p * up / u / w.D : 0, duq = u > 1e-6 ? w.q * uq / u / w.D : 0,
          p1 = w.k1 * d[i] + w.ky1 * y + w.f1, p2 = w.k2 * d[i] + w.ky2 * y - w.o2 * t, p3 = w.k3 * d[i] - w.ky3 * y - w.o3 * t + 1.3,
          s1 = Math.sin(p1), c1 = Math.cos(p1), s2 = Math.sin(p2), c2 = Math.cos(p2), s3 = Math.sin(p3), c3 = Math.cos(p3),
          dyn = s2 + 0.45 * s3, mA = m * w.Ad,
          z = -w.B * up + w.As * uq * s1 + mA * uq * dyn,
          fd = -w.B * dup + w.As * (duq * s1 + uq * w.k1 * c1) + mA * (duq * dyn + uq * (w.k2 * c2 + 0.45 * w.k3 * c3)),
          fy = w.As * uq * w.ky1 * c1 + mA * uq * (w.ky2 * c2 - 0.45 * w.ky3 * c3),
          nx = -sx * fd * gx[i], ny = fd * gy[i] + fy, L = 1 / Math.sqrt(nx * nx + ny * ny + 1);
        P[i * 3 + 2] = z; Nn[i * 3] = nx * L; Nn[i * 3 + 1] = ny * L; Nn[i * 3 + 2] = L;
      }
      cloth.geo.attributes.position.needsUpdate = true;
      cloth.geo.attributes.normal.needsUpdate = true;
    }

    /* ---------- camera ---------- */
    var raf = 0, tween = null, lastDraw = 0, windTimer = 0;
    function now() { return win.performance && win.performance.now ? win.performance.now() : Date.now(); }
    function invalidate() { if (!disposed && !raf) raf = win.requestAnimationFrame(frame); }
    function draw() { try { renderer.render(scene, camera); } catch (e) { } lastDraw = now(); }
    function frame() {
      raf = 0;
      if (disposed || (!size.w && !measure())) return;
      var tnow = now(), dt = wind.last ? Math.min(0.1, (tnow - wind.last) / 1000) : 0, want = windWanted(), moving = !!tween;
      wind.last = tnow;
      if (want || wind.level > 0) {
        var lv = want ? Math.min(1, wind.level + dt / 1.2) : Math.max(0, wind.level - dt / 1.5);
        if (!want && reduced) lv = 0;
        wind.level = lv;
        wind.t += dt;
        poseCloth(wind.t, wind.level);
      }
      if (tween) stepTween();
      controls.update();
      holdInView();
      aim();
      draw();
      if (tween || moving) invalidate();
      else if ((want || wind.level > 0) && !windTimer) {
        windTimer = win.setTimeout(function () { windTimer = 0; invalidate(); }, Math.max(0, FRAME_MS - 6 - (now() - tnow)));
      }
    }
    function renderNow() { if (!disposed) draw(); }
    function getSph() {
      var ox = camera.position.x - target.x, oy = camera.position.y - target.y, oz = camera.position.z - target.z,
        r = Math.sqrt(ox * ox + oy * oy + oz * oz) || 1;
      return { az: Math.atan2(ox, oz), el: Math.asin(Math.max(-1, Math.min(1, oy / r))), r: r };
    }
    function setSph(az, el, r) {
      var ce = Math.cos(el);
      camera.position.set(target.x + r * ce * Math.sin(az), target.y + r * Math.sin(el), target.z + r * ce * Math.cos(az));
      camera.lookAt(target);
    }
    function fitDistance(az, el, aspect, share, pts, c) {
      var tv = Math.tan(FOV * PI / 360), th = tv * (aspect || 1), ce = Math.cos(el), se = Math.sin(el), sa = Math.sin(az),
        ca = Math.cos(az), m = 1 / (share || 1), best = 1, i, x, y, z, cx, cy, cz, d;
      for (i = 0; i < pts.length; i++) {
        x = pts[i].x - c.x; y = pts[i].y - c.y; z = pts[i].z - c.z;
        cx = x * ca - z * sa; cy = -x * se * sa + y * ce - z * se * ca; cz = x * ce * sa + y * se + z * ce * ca;
        d = cz + Math.max(Math.abs(cx) * m / th, Math.abs(cy) * m / tv);
        if (d > best) best = d;
      }
      return best;
    }
    function aspectNow() { return size.w > 0 && size.h > 0 ? size.w / size.h : 1.3; }
    function farFor(az, el, asp) { return fitDistance(az, el, asp || aspectNow(), FILL_HOME, ptsAll, cAll); }
    function nearFor(az, el, asp) { return fitDistance(az, el, asp || aspectNow(), FILL_NEAR, ptsFlag, cFlag); }
    function aimAt(az, el, r, asp) {
      var far = farFor(az, el, asp), near = nearFor(az, el, asp), t = far - near > 0.01 ? (far - r) / (far - near) : 0;
      t = Math.max(0, Math.min(1, t));
      return new THREE.Vector3().copy(cAll).lerp(cFlag, t);
    }
    function aim() {
      var s = getSph(), nt = aimAt(s.az, s.el, s.r);
      if (nt.distanceToSquared(target) < 1e-6) return;
      camera.position.add(nt.clone().sub(target));
      target.copy(nt); controls.target.copy(target);
    }
    function place(az, el, r, asp) {
      target.copy(aimAt(az, el, r, asp)); controls.target.copy(target);
      setSph(az, el, r);
    }
    function homeView() { var v = VIEWS.home; return { az: v.az * (state.sleeve === "right" ? -1 : 1), el: v.el }; }
    function viewOf(name) {
      var v = typeof name === "string" && VIEWS.hasOwnProperty(name) ? VIEWS[name] : VIEWS.home, sg = state.sleeve === "right" ? -1 : 1;
      return { az: name === "back" || name === "front" ? v.az : v.az * sg, el: v.el };
    }
    function updateLimits() {
      var s = getSph(), h = homeView();
      fitHome = farFor(h.az, h.el);
      controls.minDistance = nearFor(s.az, s.el);
      controls.maxDistance = Math.max(fitDistance(0, 0.07, aspectNow(), FILL_FAR, ptsAll, cAll), fitHome * 1.25);
    }
    function clampR(r, az, el) { return Math.max(nearFor(az, el), Math.min(controls.maxDistance, r)); }
    function holdInView() {
      var s = getSph(), near = nearFor(s.az, s.el);
      controls.minDistance = near;
      if (!tween && s.r < near - 0.01) setSph(s.az, s.el, near);
    }
    function stepTween() {
      var t = (now() - tween.t0) / tween.ms;
      if (t >= 1) t = 1;
      var k = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      place(tween.a.az + (tween.b.az - tween.a.az) * k, tween.a.el + (tween.b.el - tween.a.el) * k, tween.a.r + (tween.b.r - tween.a.r) * k);
      if (t >= 1) tween = null;
    }
    function tweenTo(az, el, r, ms) {
      var a = getSph(), d = az - a.az;
      while (d > PI) d -= PI * 2;
      while (d < -PI) d += PI * 2;
      tween = { a: a, b: { az: a.az + d, el: el, r: r }, t0: now(), ms: reduced ? 1 : ms };
      invalidate();
    }
    function measure() {
      var w = host.clientWidth | 0, h = host.clientHeight | 0;
      if (w < 2 || h < 2) return false;
      var pr = Math.min(2, Math.max(1, win.devicePixelRatio || 1));
      if (w === size.w && h === size.h && pr === renderer.getPixelRatio()) return false;
      var oldFit = fitHome, had = size.w > 0;
      size.w = w; size.h = h;
      renderer.setPixelRatio(pr); renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      updateLimits();
      var s = getSph();
      if (had && !tween) place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
      else if (had && tween) tween.b.r = tween.b.r * fitHome / oldFit;
      else { var hv = homeView(); place(hv.az, hv.el, fitHome); }
      controls.update();
      return true;
    }
    function onControlsChange() { invalidate(); }
    function onControlsStart() { tween = null; canvas.style.cursor = "grabbing"; wake(); }
    function onControlsEnd() { canvas.style.cursor = "grab"; }
    controls.addEventListener("change", onControlsChange);
    controls.addEventListener("start", onControlsStart);
    controls.addEventListener("end", onControlsEnd);

    function rebuild(force) {
      var ck = [state.shape, state.w, state.h, state.ohash, state.sleeve, state.sleeveW, state.height, state.key].join("|"),
        kk = ck + "|" + state.kit;
      if (force || ck !== clothKey) { buildFlag(); clothKey = ck; kitKey = ""; }
      if (force || kk !== kitKey) { buildKit(); kitKey = kk; }
      bindTextures();
    }

    var api = {
      set: function (o) {
        if (disposed || !o) return;
        var key = o.key !== undefined ? keyOf(o.key) : state.key, shape = shapeOf(o.shape, key) || state.shape,
          v, oldFit = fitHome, s = getSph(), first = !size.w;
        if ((key !== state.key || shape !== state.shape) && o.outline === undefined) { state.outline = null; state.ohash = "none"; }
        state.key = key;
        if (shape !== state.shape) {
          state.shape = shape;
          if (num(o.w, 1, 600) === null) state.w = DEF_SIZE[shape][0];
          if (num(o.h, 1, 600) === null) state.h = DEF_SIZE[shape][1];
        }
        v = num(o.w, 1, 600); if (v !== null) state.w = v;
        v = num(o.h, 1, 600); if (v !== null) state.h = v;
        if (o.outline !== undefined) { state.outline = cleanOutline(o.outline); state.ohash = hashPts(state.outline); }
        v = sleeveOf(o.sleeve); if (v) state.sleeve = v;
        v = sidesOf(o.sides); if (v) state.sides = v;
        v = kitOf(o.kit); if (v) state.kit = v;
        if (o.height !== undefined) state.height = num(o.height, 6, 600);
        if (o.sleeveWidth !== undefined) state.sleeveW = num(o.sleeveWidth, 0.2, 6);
        var before = clothKey + "#" + kitKey;
        rebuild(false);
        if (before !== clothKey + "#" + kitKey) {
          updateLimits();
          if (first) { var hv = homeView(); place(hv.az, hv.el, fitHome); }
          else {
            if (tween) tween.b.r = tween.b.r * fitHome / oldFit;
            place(s.az, s.el, clampR(s.r * fitHome / oldFit, s.az, s.el));
          }
          controls.update();
        }
        wake();
      },
      setFace: function (face, cv) {
        if (disposed || (face !== "front" && face !== "back")) return;
        faces[face].src = cv && cv.width > 0 && cv.height > 0 ? cv : null;
        applyTexture(face); wake();
      },
      refresh: function () {
        if (disposed) return;
        var names = ["front", "back"], i, f;
        for (i = 0; i < 2; i++) {
          f = faces[names[i]];
          if (f.src && (f.src.width !== f.w || f.src.height !== f.h || !f.tex)) applyTexture(names[i]);
          else if (f.tex) f.tex.needsUpdate = true;
        }
        invalidate();
      },
      view: function (name) {
        if (disposed) return;
        var v = name === "home" || !VIEWS.hasOwnProperty(name) ? homeView() : viewOf(name);
        tweenTo(v.az, v.el, farFor(v.az, v.el), 560); wake();
      },
      zoom: function (dir) {
        if (disposed) return;
        var s = tween ? tween.b : getSph(), r = clampR(s.r * Math.pow(0.8, dir > 0 ? 1 : -1), s.az, s.el);
        tweenTo(s.az, s.el, r, 240); wake();
      },
      resize: function () {
        if (disposed) return;
        if (measure()) { if (raf) { win.cancelAnimationFrame(raf); raf = 0; } renderNow(); invalidate(); }
      },
      snapshot: function (w, h, viewName) {
        if (disposed) return null;
        var out = null, oldPR = renderer.getPixelRatio(), oldSize = renderer.getSize(new THREE.Vector2()), oldAspect = camera.aspect,
          oldPos = camera.position.clone(), oldTarget = target.clone(), s = getSph();
        try {
          var cap = Math.min(4096, renderer.capabilities.maxTextureSize || 4096);
          w = Math.max(16, Math.min(cap, Math.round(w || size.w || 800)));
          h = Math.max(16, Math.min(cap, Math.round(h || size.h || 600)));
          poseCloth(3.1, 0);
          renderer.setPixelRatio(1); renderer.setSize(w, h, false);
          camera.aspect = w / h; camera.updateProjectionMatrix();
          if (typeof viewName === "string" && VIEWS.hasOwnProperty(viewName)) {
            var v = viewName === "home" ? homeView() : viewOf(viewName);
            place(v.az, v.el, farFor(v.az, v.el, w / h), w / h);
          } else {
            var k = farFor(s.az, s.el, w / h) / farFor(s.az, s.el, oldAspect || 1);
            place(s.az, s.el, s.r * k, w / h);
          }
          renderer.render(scene, camera);
          out = doc.createElement("canvas"); out.width = w; out.height = h;
          var ctx = out.getContext("2d");
          ctx.fillStyle = bg; ctx.fillRect(0, 0, w, h); ctx.drawImage(canvas, 0, 0, w, h);
        } catch (e) { out = null; }
        try {
          renderer.setPixelRatio(oldPR); renderer.setSize(oldSize.x, oldSize.y, false);
          camera.aspect = oldAspect; camera.updateProjectionMatrix();
          target.copy(oldTarget); controls.target.copy(target); camera.position.copy(oldPos); camera.lookAt(target);
          poseCloth(wind.t, wind.level);
          renderer.render(scene, camera);
        } catch (e2) { }
        return out;
      },
      // extra (not in the contract): small debug numbers for testing
      stats: function () {
        if (disposed) return null;
        var m = renderer.info.memory, r = renderer.info.render;
        return { geometries: m.geometries, textures: m.textures, frame: r.frame, calls: r.calls, triangles: r.triangles,
          clothVertices: cloth ? cloth.n : 0, wind: wind.level, onScreen: onScreen, reducedMotion: reduced };
      },
      dispose: function () {
        if (disposed) return;
        disposed = true;
        if (raf) win.cancelAnimationFrame(raf);
        if (windTimer) win.clearTimeout(windTimer);
        raf = 0; windTimer = 0; tween = null;
        try { if (ro) ro.disconnect(); } catch (e) { }
        try { if (io) io.disconnect(); } catch (e) { }
        try { if (mq) { if (mq.removeEventListener) mq.removeEventListener("change", onMotion); else if (mq.removeListener) mq.removeListener(onMotion); } } catch (e) { }
        win.removeEventListener("resize", onWinResize);
        doc.removeEventListener("visibilitychange", onVis);
        canvas.removeEventListener("webglcontextlost", onLost, false);
        canvas.removeEventListener("webglcontextrestored", onRestored, false);
        canvas.removeEventListener("pointerdown", wake);
        canvas.removeEventListener("wheel", wake);
        controls.removeEventListener("change", onControlsChange);
        controls.removeEventListener("start", onControlsStart);
        controls.removeEventListener("end", onControlsEnd);
        controls.dispose();
        disposeList(flagGeos); disposeList(kitGeos);
        if (ground) ground.geometry.dispose();
        var list = [frontMat, backMat, groundMat, groundTex, placeTex, faces.front.tex, faces.back.tex], k;
        for (k in M) if (M.hasOwnProperty(k)) list.push(M[k]);
        for (k = 0; k < list.length; k++) try { if (list[k]) list[k].dispose(); } catch (e3) { }
        faces.front.tex = faces.back.tex = faces.front.src = faces.back.src = null;
        cloth = null;
        try { renderer.dispose(); renderer.forceContextLoss(); } catch (e4) { }
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    };
    function onWinResize() { api.resize(); }
    function onLost(e) { e.preventDefault(); }
    function onRestored() { invalidate(); }
    function onVis() { if (!doc.hidden) invalidate(); }
    function onMotion() { reduced = !!(mq && mq.matches); if (reduced) { wind.level = 0; poseCloth(wind.t, 0); } invalidate(); }
    canvas.addEventListener("webglcontextlost", onLost, false);
    canvas.addEventListener("webglcontextrestored", onRestored, false);
    canvas.addEventListener("pointerdown", wake);
    canvas.addEventListener("wheel", wake, { passive: true });
    doc.addEventListener("visibilitychange", onVis);
    try { if (mq) { if (mq.addEventListener) mq.addEventListener("change", onMotion); else if (mq.addListener) mq.addListener(onMotion); } } catch (e6) { }
    var ro = null;
    if (win.ResizeObserver) { ro = new win.ResizeObserver(function () { api.resize(); }); ro.observe(host); }
    if (win.IntersectionObserver) {
      io = new win.IntersectionObserver(function (en) { onScreen = !!(en[en.length - 1] && en[en.length - 1].isIntersecting); if (onScreen) invalidate(); });
      io.observe(host);
    }
    win.addEventListener("resize", onWinResize);

    rebuild(true);
    updateLimits();
    var hv0 = homeView();
    place(hv0.az, hv0.el, fitHome);
    if (!measure()) controls.update();
    wake();
    canvas.setAttribute("data-ardor-flag3d", "ready");
    return api;
  }

  root.ArdorFlag3D = { create: create, version: "1.0.0", poster: poster };
})(typeof window !== "undefined" ? window : this);
